import React from "react";
import {LinkOutlined} from "@ant-design/icons";

export default function Briefing() {

	return (
		<div style={{overflow: "auto"}}>
			<div className="dashboard_box">
				<div className="dashboard_box">
					<h2 className="dashboard_header">Briefing</h2>
				</div>
			</div>
			<a href="https://drive.google.com/drive/folders/1GgfnYMa91F9WyjuDaQKQSCnnvNnJq72F?usp=drive_link" target="_blank" rel="noopener noreferrer">
				<LinkOutlined style={{marginRight: 12}} />
				Zum Briefing
			</a>
		</div>
	);
}
